module.exports = __webpack_public_path__ + "img/help.181787e1.jpg";